import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight, CalendarDays, Check, HeartHandshake, Newspaper, Users } from 'lucide-react';

const Membership: React.FC = () => {
  const { t } = useTranslation();

  const benefits = [
    { icon: CalendarDays, label: 'Access to JAJ events' },
    { icon: Newspaper, label: 'Monthly newsletter' },
    { icon: Users, label: 'Voting rights in JAJ elections' },
    { icon: HeartHandshake, label: 'A welcoming community network' },
  ];

  return (
    <section className="page-section">
      <div className="page-container">
        <div className="page-intro">
          <p className="eyebrow">Everyone is welcome</p>
          <h1 className="page-title">{t('membership.title', 'Membership')}</h1>
          <p className="page-description">
            Become part of a community that celebrates Japanese culture, builds lasting friendships, and brings people together across Jacksonville.
          </p>
        </div>

        <div className="grid overflow-hidden bg-white shadow-[0_16px_50px_rgba(23,32,51,0.08)] lg:grid-cols-[1.1fr_0.9fr]">
          <div className="p-6 sm:p-10 lg:p-12">
            <h2 className="section-title">{t('membership.benefits.title', 'Member Benefits')}</h2>
            <div className="mt-8 grid gap-px bg-[#e3e7ec] sm:grid-cols-2">
              {benefits.map(({ icon: Icon, label }) => (
                <div key={label} className="flex min-h-32 flex-col justify-between bg-white p-5">
                  <Icon className="h-6 w-6 text-[#d95f75]" />
                  <p className="mt-6 font-bold text-[#172033]">{label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-center bg-[#2457a7] p-7 text-white sm:p-10 lg:p-12">
            <p className="text-xs font-bold uppercase text-white/60">Start here</p>
            <h2 className="mt-3 text-3xl font-extrabold">{t('membership.join.title', 'How to Join')}</h2>
            <p className="mt-5 leading-7 text-white/75">
              {t('membership.join.description', 'Join our vibrant community by becoming a member today. Fill out the membership form and submit your application.')}
            </p>
            <div className="mt-7 space-y-3 text-sm font-semibold text-white/85">
              <p className="flex gap-3"><Check className="h-5 w-5 text-[#f4b7c2]" /> Open to every nationality and background</p>
              <p className="flex gap-3"><Check className="h-5 w-5 text-[#f4b7c2]" /> Simple online application</p>
            </div>
            <a
              href="https://docs.google.com/forms/u/0/d/e/1FAIpQLSduFmpiDJQArfVyKGaKu37XI96nKFoN8A8zAAObz5sOf6eNfQ/viewform?pli=1"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-8 bg-white text-[#172033] hover:bg-[#f4d5da]"
            >
              {t('membership.join.button', 'Apply for Membership')}
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Membership;
